export const BRAND = {
  name: "SECURE WATCH",
  tagline: "A Smart Security Solution",
  phone: "9127070100",
  phoneDisplay: "+91 91270 70100",
  monitoringPhone: "9127070400",
  monitoringPhoneDisplay: "+91 91270 70400",
  email: "vssvirtual1@gmail.com",
  address:
    "1st Floor, House No. 21, near Darandha Masjid, Dwarandha, Six Mile, Guwahati, Assam 781022",
  city: "Guwahati, Assam",
  whatsapp: "919127070100",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_cctv-leads/artifacts/pv0g9urg_secure%20watch-5.JPG",
  // Verified Google Maps listing (from user)
  mapsUrl:
    "https://www.google.com/maps/dir//Secure+Watch,+Masjid,+1st+Floor+House+No,+21,+near+Darandha+Road,+Guwahati,+Assam+781022/@26.1367782,91.8135514,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x375a59511af1eac5:0x9f1f1203f434b9fa!2m2!1d91.8135514!2d26.1367782",
  mapsEmbed:
    "https://maps.google.com/maps?q=Secure+Watch+Six+Mile+Guwahati&ll=26.1367782,91.8135514&z=17&output=embed",
  mapsCoords: { lat: 26.1367782, lng: 91.8135514 },
};

export const waLink = (msg = "Hi Secure Watch, I want to know more about your CCTV remote monitoring service.") =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:+${BRAND.whatsapp}`;
export const monitoringTelLink = `tel:+91${BRAND.monitoringPhone}`;
